/**
 * Runs the `before()` method on the given array of middleware in sequence.
 *
 * @param {object} context The context object from the beforeEach router method.
 * @param {array} middleware The middleware array defined in the route's `meta`
 * @param {int} index The index of the current middleware being run.
 * @returns The next context function
 */
function middlewarePipeline (context, middleware, index) {
	const nextMiddleware = middleware[index];

	if (!nextMiddleware) {
		return context.next;
	}

	return () => {
		const nextPipeline = middlewarePipeline(
			context, middleware, index + 1
		);

		nextMiddleware.before({ ...context, next: nextPipeline });
	};
}

export default middlewarePipeline;
